var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BfSlideOutNav',{attrs:{"is-open":_vm.isMobileNavOpen,"nav-items":_vm.navItems},on:{"close-nav":_vm.closeNav}})}
var staticRenderFns = []

export { render, staticRenderFns }